import styled from "styled-components";

import {
  alignItemsCenter,
  bp,
  circle,
  flexCenter,
  flexSpBetween,
  media,
  pseudo,
  rem,
  size,
} from "@styles/Utilities.styled";


export const StyledWithPatientNavbar = styled.nav`
  position: fixed;
  top: 0;
  left: var(--sidebar-width);
  background-color: var(--clr-white);
  width: calc(100% - var(--sidebar-width));
  border-bottom: 1px solid var(--clr-gray-150);
  transition: transform var(--network-notification-transition-duration);
  z-index: 2;

  &.show-notification {
    transform: translateY(var(--network-notification-height));
  }

  &.hide-notification {
    transition-delay: var(--network-notification-dismiss-delay);
  }

  .upper-nav {
    width: 100%;
    ${alignItemsCenter}
    ${flexSpBetween}
    gap: 2rem;
    padding: 1rem 2.5rem 0;
    font-size: ${rem(14)};

    a {
      transition: color 0.1s;

      &:hover {
        color: var(--clr-primary-400);
      }
    }
  }

  .nav-links {
    ${alignItemsCenter}
    gap: 1.5rem;
    max-width: 100%;
    padding-top: 0.5rem;
    padding-left: 2.5rem;
    padding-right: 5rem;
    font-size: ${rem(13)};
    /* outline: 1px solid blue; */

    ${media(bp.large2)} {
      padding-right: 2.5rem;
    }

    &-item {
      a {
        padding-top: 1rem;
        padding-bottom: 0.75rem;
        /* outline: 1px solid red; */

        &.active {
          position: relative;
          color: var(--clr-primary-400);
          font-weight: 500;

          &::before {
            ${pseudo}
            top: 94%;
            left: 0;
            width: 100%;
            height: 3px;
            background-color: var(--clr-primary-400);
            border-radius: 100vmax;
          }
        }
      }
    }
  }

  .footnotes-btn {
    ${flexCenter}
    ${circle(rem(45))}
    color: var(--clr-white);
    background-color: var(--clr-accent);

    svg {
      font-size: 1.5rem;
    }
  }
`;

export const StyledWrapper = styled.div`
  ${size("100%")}
  max-width: ${rem(1440)};
  /* margin-inline: auto; */
  transition: transform var(--network-notification-transition-duration);
  /* outline: 1px solid red; */

  &.show-notification {
    transform: translateY(var(--network-notification-height));
  }

  &.hide-notification {
    transform: translateY(0);
    transition-delay: var(--network-notification-dismiss-delay);
  }
`;
